/** Sorting by column of the tables, without React: the web app and the exports of the API. */
/**
 * Sorting by column (11/10/2026, every table 18/10/2026): a click on the
 * heading sorts A→Z, the second Z→A, the third goes back to the order of the
 * rows themselves.
 */
export function nextSort(current, key) {
    if (current?.key !== key)
        return { key, direction: 1 };
    return current.direction === 1 ? { key, direction: -1 } : null;
}
function isEmpty(value) {
    return value === null || value === '' || (typeof value === 'number' && Number.isNaN(value));
}
/** Two values in the order of `direction`, the empty ones last either way. */
export function compareSortValues(a, b, direction = 1) {
    if (isEmpty(a) || isEmpty(b))
        return Number(isEmpty(a)) - Number(isEmpty(b));
    if (typeof a === 'number' && typeof b === 'number')
        return direction * (a - b);
    return direction * String(a).localeCompare(String(b), 'it', { numeric: true });
}
/** A decimal amount from the API as a number to sort by (never to compute with). */
export function amountSort(value) {
    return value === null || value === undefined || value === '' ? null : Number(value);
}
export function sortRows(rows, sort, value) {
    if (!sort || !value)
        return rows;
    return [...rows].sort((a, b) => compareSortValues(value(a), value(b), sort.direction));
}
//# sourceMappingURL=column-sort.js.map